import React, { FunctionComponent, useState } from 'react'

//OpenLayers
import OlLayerGroup from "ol/layer/Group";
import OlLayerBase from "ol/layer/Base";

//Custom
import MapContext from "./MapContext";

//Types
import { BoolSettings, StringSettings } from "@/@types/common";
import { MapContextProviderProps } from "@/@types/context/MapContext";
import { findLayer, flattenLayers } from '@/lib/olHelpers';
import BaseLayer from 'ol/layer/Base';

const MapContextProvider: FunctionComponent<MapContextProviderProps> = (props) => {

  const [ forceRefreshCounter, setForceRefreshCounter] = useState(0);

  const [ sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const { map, initOptions} = props;

  const setLayerVisibility = (id: string, isVisible: boolean) => {
    const key: string = "maplayers";

    const item = localStorage.getItem(key)
    const settings = item ? JSON.parse(item) : null;
    if (settings === null || Object.keys(settings).length === 0) {
      localStorage.setItem(key, JSON.stringify({ [id]: isVisible }));
    } else {
      settings[id] = isVisible;
      localStorage.setItem(key, JSON.stringify(settings));
    }

    setForceRefreshCounter(prev => prev + 1);
  }

  const getLayerVisibility = () => {
    const key: string = "maplayers";

    const item = localStorage.getItem(key)
    const settings = item ? JSON.parse(item) : null;

    return settings ? settings as BoolSettings : {} as BoolSettings;
  }

  const setLayerTime = (id: string, time: string, syncGroup: boolean) => {
    const key = "layerstime";

    const item = localStorage.getItem(key)
    const settings = item ? JSON.parse(item) : null;
    if (settings === null || Object.keys(settings).length === 0) {
      localStorage.setItem(key, JSON.stringify({ [id]: time }));
    } else {
      settings[id] = time;
      localStorage.setItem(key, JSON.stringify(settings));
    }

    if (syncGroup) {
      if (map) {
        const allLayers = flattenLayers(map.getLayers().getArray(), 2);
        const groupLayers = allLayers.filter(x => x instanceof OlLayerGroup)
        const parentLayer = groupLayers.filter(x => x.getLayersArray().find(y => y.get("id") === id) !== undefined);
        if (parentLayer && parentLayer.length === 1) {
          //@ts-ignore
          const siblingLayers = parentLayer[0].getLayers().getArray().filter(x => x.get("id") !== id);
          siblingLayers.forEach((x: OlLayerBase) => {
            const sid = x.get("id");
            settings[sid] = time
            localStorage.setItem(key, JSON.stringify(settings));
          })
        }
      }
    }

    setForceRefreshCounter(prev => prev + 1);

  }

  const getLayerTime = () => {
    const key = "layerstime";
    const item = localStorage.getItem(key);
    const settings = item ? JSON.parse(item): null;

    return settings ? settings as StringSettings: {} as StringSettings;
  }


  const providerValue = {
    map,
    initOptions,
    setLayerVisibility,
    getLayerVisibility,
    setLayerTime,
    getLayerTime,
    forceRefreshCounter,
    sidebarCollapsed,
    setSidebarCollapsed
  }

  return (
    <MapContext.Provider value={providerValue}>
      {props.children}
    </MapContext.Provider>
  )

}

export default MapContextProvider;